var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.047 5.18c-.634 0-.989.555-.822 1.05.8 2.371 2.28 5.899 4.465 8.085 2.186 2.185 5.714 3.665 8.084 4.465.495.167 1.05-.188 1.05-.822v-2.412l-2.1-1.168-2.241 1.12a.951.951 0 01-.605.084l.18-.934-.18.934h-.002l-.004-.002-.008-.001-.024-.005a3.859 3.859 0 01-.327-.084 7.284 7.284 0 01-.83-.297 7.387 7.387 0 01-2.32-1.55 7.419 7.419 0 01-1.554-2.323 7.357 7.357 0 01-.366-1.083 3.523 3.523 0 01-.017-.076l-.005-.024-.002-.008v-.004s0-.002.932-.183l-.933.181a.95.95 0 01.083-.606l1.12-2.241L8.458 5.18H6.047zm4.316 4.866c.043.139.106.32.195.527.218.51.579 1.154 1.15 1.725.57.57 1.212.93 1.72 1.146.206.087.386.15.525.193l1.92-.96a1.901 1.901 0 011.774.04l2.101 1.167c.603.336.977.972.977 1.662v2.412c0 1.823-1.727 3.242-3.559 2.623-2.41-.813-6.303-2.404-8.82-4.922-2.518-2.517-4.11-6.41-4.923-8.82-.618-1.833.801-3.56 2.624-3.56h2.411c.691 0 1.328.375 1.663.979l1.163 2.095c.304.548.319 1.212.038 1.773l-.96 1.92z",
    fill: "#252B47"
  })));
}

export default SvgPhone;